import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogConfig,
} from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { QuestionControlService } from '../../../../inputfileds/form_services/question-control.service';
import { ApiservicesService } from '../../../../Services/Apis/apiservices.service';
import { environment } from '../../../../../environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AcademicyearsformService } from '../../../../inputfileds/form_services/academics/academicyearsform/academicyearsform.service';
import { Inputfiledsbase } from '../../../../inputfileds/models/inputfiledsbase';
import { Observable, Subject, takeUntil } from 'rxjs';
import { AddshiftComponent } from '../../../settings/workingdays/shifttimings/addshift/addshift.component';
import { ShiftComponent } from '../../../settings/workingdays/shifttimings/shift/shift.component';
import { AddholidaysComponent } from '../../../settings/workingdays/holidays/addholidays/addholidays.component';
import { AddweekoffComponent } from '../../../settings/workingdays/weekoff/addweekoff/addweekoff.component';
import { WeekoffComponent } from '../../../settings/workingdays/weekoff/weekoff/weekoff.component';
import { HolidaysComponent } from '../../../settings/workingdays/holidays/holidays/holidays.component';
import { ToastService } from '../../../../Services/toast/toast.service';
import { TranslateDirective } from '../../../../components/Utilites/Directives/translate.directive';

export interface yearDetailsView {
  id: string;
  batch: number;
  semister: string;
  course_name: string;
}

@Component({
    selector: 'app-academicyearsdetails',
    imports: [
    WeekoffComponent,
    HolidaysComponent,
    FormsModule,
    MatFormFieldModule,
    MatMenuModule,
    MatTableModule,
    MatIconModule,
    RouterModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    MatExpansionModule,
    CommonModule,
    MatTabsModule,
    MatDividerModule,
    ShiftComponent,
    TranslateDirective
],
    providers: [QuestionControlService, ApiservicesService],
    templateUrl: './academicyearsdetails.component.html',
    styleUrls: ['./academicyearsdetails.component.scss']
})
export class AcademicyearsdetailsComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['semister', 'batch', 'course_name', 'action'];
  createsemister: Inputfiledsbase<any>[] = [];
  createsemister$: Observable<Inputfiledsbase<any>[]> | undefined;
  createsemisterForm!: FormGroup;
  BatchData: any;
  academic_year_id: any;
  yearsDetailsData: any;
  dataSource = new MatTableDataSource<yearDetailsView>();
  subjects: any[] = [];
  onerror =
    'https://dbraeiassetmanagement.blob.core.windows.net/dbraimt/prod/home/Placeholders/Placeholder_Image.jpg';
  editsubjectdata: any = null;
  isSubjectEnabled = false;
  assetUrl: string = environment.ASSET_URL;
  assetContainer: string = environment.ASSET_CONTAINER;
  yearsSemisterData: any;
  datasend: any;
  total_count: any;
  paginationData: any;
  private destroy$ = new Subject<void>();

  @ViewChild('createSemesterDialog') createSemesterDialog!: TemplateRef<any>;
  routedata: any;

  constructor(
    private router: Router,
    private apiservice: ApiservicesService,
    private dialog: MatDialog,
    private dataService: AcademicyearsformService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    private qcs: QuestionControlService,
    private toast: ToastService,
    public route: ActivatedRoute
  ) {
    this.routedata = this.route.snapshot?.queryParams['data'];
  }

  ngOnInit(): void {
    this.getacadamicsdetails();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  pagination(event: any) {
    this.paginationData = event;
    this.getacademicyearsemisterDetails();
  }

  getacadamicsdetails() {
    this.apiservice
      .getrespectiveacadamicyearslist(this.routedata)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          this.academic_year_id = res.id
          this.BatchData = res;
          this.initializeSemesterForm();
          this.getacademicyearsemisterDetails();
        },
        error: (err) => {
          this.toast.showToast(
            'danger',
            'Failed to load academic year details'
          );
          console.error('Error loading academic year details:', err);
        },
      });
  }

  initializeSemesterForm() {
    this.createsemister$ = this.dataService.getacadamicsemisterForm({
      course_id: this.BatchData?.course_id,
    });

    this.createsemister$.pipe(takeUntil(this.destroy$)).subscribe({
      next: (q) => {
        this.createsemister = q;
        this.createsemisterForm = this.qcs.toFormGroup(
          this.createsemister as Inputfiledsbase<string>[]
        );
      },
      error: (err) => {
        console.error('Error initializing semester form:', err);
      },
    });
  }

  getacademicyearsemisterDetails(): void {
    if (!this.BatchData?.id) return;

    const data = {
      id: this.BatchData.id,
      course_ID: this.BatchData.course_id,
    };

    // this.apiservice
    //   .getAcademicSemister(data, this.paginationData)
    //   .pipe(takeUntil(this.destroy$))
    //   .subscribe({
    //     next: (res: any) => {
    //       this.yearsDetailsData = res?.rows;
    //       this.total_count = res?.total_count;
    //       this.dataSource.data = this.yearsDetailsData;
    //     },
    //     error: (err) => {
    //       this.toast.showToast('danger', 'Failed to load semester details');
    //       console.error('Error loading semester details:', err);
    //     },
    //   });
  }

  openCreateSemisterDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__fadeIn'];
    dialogConfig.minWidth = '80%';
    dialogConfig.minHeight = '65vh';
    dialogConfig.maxHeight = '65vh';
    dialogConfig.data = { batchdetails: this.yearsDetailsData };
    const dialogRef = this.dialog.open(this.createSemesterDialog, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.getacademicyearsemisterDetails();
    });
  }

  closeDialog(event: any) {
    this.dialog.closeAll();
    this.getacademicyearsemisterDetails();
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.remove('animate__fadeIn');
    document
      .getElementsByClassName('animate__animated')[0]
      .classList.add('animate__fadeOut');
  }

  onSaveClick(): void {
    this.dialog.closeAll();
  }

  onSubmit() {
    if (!this.createsemisterForm.valid) {
      this.toast.showToast('warning', 'Please fill all required fields');
      return;
    }

    const organizationData = sessionStorage.getItem('user');
    let organizationId: number | null = null;
    const payload = this.createsemisterForm.value;

    if (organizationData) {
      try {
        const parsedData = JSON.parse(organizationData);
        organizationId = parsedData.data?.organization_id || null;
      } catch (error) {
        console.error('Error parsing organization data:', error);
      }
    }

    if (organizationId === null) {
      this.toast.showToast('danger', 'Organization ID not found');
      return;
    }

    // Convert dates to UTC format
    if (payload.start_date) {
      payload.start_date = this.convertToUTCDate(payload.start_date);
    }

    if (payload.end_date) {
      payload.end_date = this.convertToUTCDate(payload.end_date);
    }

    this.datasend = {
      organization_id: organizationId,
      academic_year_id: this.BatchData.id,
      academic_regulation_id: this.BatchData.academic_regulation_id,
      course_id: this.BatchData.course_id,
      semister_id: payload.semister_id,
      start_date: payload.start_date,
      end_date: payload.end_date,
    };

    this.createAPi(this.datasend);
  }

  private convertToUTCDate(date: Date): string {
    const localDate = new Date(date);
    return new Date(
      Date.UTC(
        localDate.getFullYear(),
        localDate.getMonth(),
        localDate.getDate()
      )
    )
      .toISOString()
      .split('T')[0];
  }

  createAPi(event: any) {
    this.apiservice
      .createacademicyearsemisters(event)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          if (res.code === 201 && res.status === true) {
            this.closeDialog(true);
            this.toast.showToast('success', 'Saved Successfully');
            this.createsemisterForm.reset();
          } else {
            this.toast.showToast(
              'danger',
              res.message || 'Failed to save semester'
            );
          }
        },
        error: (err) => {
          this.toast.showToast('danger', 'An error occurred while saving');
          console.error('API Error:', err);
        },
      });
  }

  backPage(): void {
    this.router.navigate(['/academicyears']);
  }

  openShiftDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__fadeIn'];
    dialogConfig.minWidth = '25%';
    dialogConfig.minHeight = '30vh';
    dialogConfig.data = { academic_calendar_id: this.routedata };
    const dialogRef = this.dialog.open(AddshiftComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.dataService.refreshDataOnSubmit();
    });
  }

  openholidayDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__fadeIn'];
    dialogConfig.minWidth = '25%';
    dialogConfig.minHeight = '30vh';
    dialogConfig.data = { academic_calendar_id: this.routedata };
    const dialogRef = this.dialog.open(AddholidaysComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.dataService.refreshDataOnSubmit();
    });
  }

  openweekoffDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = ['animate__animated', 'animate__fadeIn'];
    dialogConfig.minWidth = '25%';
    dialogConfig.minHeight = '30vh';
    dialogConfig.data = { academic_calendar_id: this.routedata };
    const dialogRef = this.dialog.open(AddweekoffComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      this.dataService.refreshDataOnSubmit();
    });
  }
}
